import { FieldErrors } from 'react-hook-form';

// `ref` can be a DOM node (React fiber properties, cyclic) and `types` repeats the messages.
const NON_PATH_KEYS = ['ref', 'types'];

const isErrorObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const isFieldError = (value: Record<string, unknown>) =>
  typeof value.message === 'string' || typeof value.type === 'string';

// Depth-first in the order RHF stores the errors, so nested and field-array paths
// (`customers.0.location`) are returned in full.
const collectFieldErrors = (
  errors: unknown,
  parentPath = ''
): { path: string; message?: string }[] => {
  if (!isErrorObject(errors)) {
    return [];
  }

  if (parentPath && isFieldError(errors)) {
    return [{ path: parentPath, message: errors.message as string | undefined }];
  }

  return Object.entries(errors)
    .filter(([key]) => !NON_PATH_KEYS.includes(key))
    .flatMap(([key, value]) =>
      collectFieldErrors(value, parentPath ? `${parentPath}.${key}` : key)
    );
};

export const getFirstErrorMessage = (errors: FieldErrors): string | undefined =>
  collectFieldErrors(errors).find(({ message }) => message)?.message;

export const getErrorPaths = (errors: FieldErrors): string[] =>
  collectFieldErrors(errors).map(({ path }) => path);
